import type { ExperienceRequestRow, RequestsSummary } from "./types";
type AssembleExperienceRequestRow = {
  readonly experience_request_id: string;
  readonly coworld: string | null;
  readonly episodes: number;
  readonly compute_cost_credits: number;
  readonly last_activity_at: string;
};
function toRequestRow(r: AssembleExperienceRequestRow): ExperienceRequestRow {
  return {
    id: r.experience_request_id,
    createdAt: r.last_activity_at,
    completedAt: r.last_activity_at,
    status: null,
    episodeCount: r.episodes,
    completedCount: null,
    failedCount: null,
    variantId: null,
    coworldName: r.coworld,
    costCredits: r.compute_cost_credits,
  };
}
export function buildRequests({
  requests,
  windowStartedAt,
  windowEndedAt,
}: {
  readonly requests: readonly AssembleExperienceRequestRow[] | null;
  readonly windowStartedAt: string | null;
  readonly windowEndedAt: string | null;
}): RequestsSummary {
  if (!requests) {
    return {
      inWindow: [],
      recent: [],
      totalCount: null,
      perDayInWindow: null,
    };
  }

  const recent = requests
    .toSorted(
      (a, b) => Date.parse(b.last_activity_at) - Date.parse(a.last_activity_at),
    )
    .map(toRequestRow);

  if (!windowStartedAt || !windowEndedAt) {
    return {
      inWindow: [],
      recent,
      totalCount: requests.length,
      perDayInWindow: null,
    };
  }

  const start = Date.parse(windowStartedAt);
  const end = Date.parse(windowEndedAt);
  const inWindow: ExperienceRequestRow[] = requests
    .filter((r) => {
      const at = Date.parse(r.last_activity_at);
      return !Number.isNaN(at) && at >= start && at <= end;
    })
    .map(toRequestRow);
  const days = (end - start) / 86400000;
  const perDayInWindow = days >= 1 ? inWindow.length / days : null;
  return { inWindow, recent, totalCount: requests.length, perDayInWindow };
}
